import React from "react";

import AddReview from "../components/Review/AddReview";
import NotFoundPage from "./NotFoundPage";
import { useNavigate } from "react-router-dom";

const AddReviewPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(true);
  const customerUniqueCode = sessionStorage.getItem("Customer-vUniqueCode");
  const contractorUniqueCode = sessionStorage.getItem("Contractor-vUniqueCode");
  React.useEffect(() => {
    if (customerUniqueCode) {
      setLoading(false);
    } else if (contractorUniqueCode) {
      setLoading(false);
    } else {
      navigate("/login");
    }
  }, [customerUniqueCode, navigate, contractorUniqueCode]);

  if (loading) {
    return null;
  }

  return customerUniqueCode ? <AddReview /> : <NotFoundPage />;
};

export default AddReviewPage;
